import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Focus from "./components/Focus";
import Timeline from "./components/Timeline";
import Tactics from "./components/Tactics";
import Reading from "./components/Reading";
import Playbook from "./components/Playbook";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";
import Seo from "./components/Seo";

export default function Home() {
  return (
    <div className="bg-background-50 font-sans text-foreground-900">
      <Seo />
      <Navbar />
      <main>
        <Hero />
        <Focus />
        <Timeline />
        <Tactics />
        <Reading />
        <Playbook />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}